import { ToWarekiFormatter } from '@/features/openProjects/utils/toWarekiFormatter';
import {
    Card,
    CardContent,
    CardHeader,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from 'app-template-lib/components/shadcn';
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

type kpi = {
    id: string;
    jigyo_year: number;
    kijun_val: number;
    kijun_year: number;
    jisseki_val: number;
    kpi_sort: number;
    mokuhyo_val: number;
    process_cd: number;
    shihyo_cd: number;
    shihyo_kind: string;
    shihyo_name: string;
    shutten: string;
    tani: string;
    tassei_rate: number;
    t_sai_jigyo_id: string;
    t_sai_jigyo: {
        saijigyo_name: string;
    };
};

export interface KPICardProps {
    kpis: kpi[] | undefined;
}

/**
 * KPIカードコンポーネント
 * @param param0
 * @returns
 */
export function KPICard({ kpis }: KPICardProps) {
    const [viewKPIs, setViewKPIs] = useState<kpi[][]>([]);
    // const kpiDatas = kpis;
    const { jigyoYear }: { jigyoYear: string } = useParams();

    // データ初期化
    const initData = (kpis: KPICardProps['kpis']) => {
        const tmpViewKpi: { [key: string]: kpi[] } = {};
        if (kpis) {
            kpis.forEach((item) => {
                var cat = item['shihyo_cd'];
                if (typeof tmpViewKpi[cat] == 'undefined') tmpViewKpi[cat] = [];
                tmpViewKpi[cat].push(item);
            });
        }
        const tmpViewKpis: kpi[][] = [];
        Object.keys(tmpViewKpi).forEach((key) => {
            let kpi: kpi[] = [];
            tmpViewKpi[key].forEach((item) => {
                if (item.jigyo_year > Number(jigyoYear) - 3) {
                    kpi.push(item);
                }
            });
            let sortKpis = kpi.sort((a, b) => a.jigyo_year - b.jigyo_year);

            tmpViewKpis.push(sortKpis);
        });

        const sortTmpKpis = tmpViewKpis.sort((a, b) => a[0].kpi_sort - b[0].kpi_sort);
        setViewKPIs(sortTmpKpis);
    };

    // 初回データレンダリング時の処理
    useEffect(() => {
        if (kpis) {
            initData(kpis);
        }
    }, [kpis]);

    return (
        <>
            {viewKPIs.length > 0 ? (
                viewKPIs.map((viewKpi: kpi[]) => (
                    <Card className="bg-secondary rounded-t-md shadow-none mx-2 md:mx-0 mt-3">
                        <CardHeader className="flex bg-primary rounded-t-md p-3">
                            <h2 className="text-white text-sm">
                                {viewKpi[0].shihyo_name} {viewKpi[0].tani ? '(' + viewKpi[0].tani + ')' : ''}
                            </h2>
                        </CardHeader>
                        <CardContent className="container mx-auto grid grid-cols-1 shadow-none pt-3 p-4 pt-0 gap-2 bg-white">
                            <Table>
                                <TableHeader>
                                    <TableRow>
                                        <TableHead></TableHead>
                                        {viewKpi.map((item) => (
                                            <TableHead key={item.jigyo_year}> {ToWarekiFormatter(item.jigyo_year)}</TableHead>
                                        ))}
                                    </TableRow>
                                </TableHeader>
                                <TableBody>
                                    <TableRow>
                                        <TableCell className="font-medium">目標値</TableCell>
                                        {viewKpi.map((item) => (
                                            <TableCell key={item.jigyo_year}>{item.mokuhyo_val}</TableCell>
                                        ))}
                                    </TableRow>
                                    <TableRow>
                                        <TableCell className="font-medium">実績値</TableCell>
                                        {viewKpi.map((item) => (
                                            <TableCell key={item.jigyo_year}>{item.jisseki_val}</TableCell>
                                        ))}
                                    </TableRow>
                                    {/* <TableRow>
                                        <TableCell className="font-medium">達成度</TableCell>
                                        {viewKpi.map((item) => (
                                            <TableCell key={item.jigyo_year}>{item.tassei_rate}</TableCell>
                                        ))}
                                    </TableRow> */}
                                </TableBody>
                            </Table>
                        </CardContent>
                    </Card>
                ))
            ) : (
                <Card className="shadow-none rounded-md">
                    <CardContent className="p-3 text-sm min-h-10"></CardContent>
                </Card>
            )}
        </>
    );
}
